import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';

class ModalComponent extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    isActive: PropTypes.bool,
    onClose: PropTypes.func,
  };

  renderBody = () => {
    const { body } = this.props;

    if (typeof body === 'string') {
      return (
        <div>
          {body}
        </div>
      );
    }
    return body;
  };

  render () {
    const {
      title,
      isActive,
      onClose,
    } = this.props;

    return (

      <Modal
        show={isActive}
        onHide={onClose}
        {...this.props}
      >
        <Modal.Header>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {this.renderBody()}
        </Modal.Body>
      </Modal>
    );
  }
}

export default ModalComponent;


// WEBPACK FOOTER //
// ./src/app/components/complex/modalComponent.js